import { database } from './firebase';
import { ref, get } from 'firebase/database';

// Cache pro otázky
let questionsCache = {};
let lastFetchTime = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minut

// Helper: Načíst otázky z Firebase podle kategorie
async function fetchFromFirebase(category) {
  // Zkontroluj cache
  if (questionsCache[category] && lastFetchTime && (Date.now() - lastFetchTime < CACHE_DURATION)) {
    console.log(`questionsApi: Vracím ${questionsCache[category].length} otázek z cache pro ${category}`);
    return questionsCache[category];
  }

  console.log(`questionsApi: Načítám otázky z Firebase pro ${category}`);

  const snapshot = await get(ref(database, category));

  if (!snapshot.exists()) {
    console.log(`questionsApi: Žádná data pro ${category}`);
    return [];
  }

  const data = snapshot.val();

  // Firebase vrací pole nebo objekt - převedeme na pole
  const questions = Array.isArray(data)
    ? data.filter(q => q !== null)
    : Object.values(data);

  // Transformace dat do formátu kompatibilního s webem
  const formattedQuestions = questions.map((q, index) => ({
    id: q.id || index,
    question_text: q.questionText,
    options: q.options,
    correct_answer_index: q.correctAnswerIndex,
    explanation: q.explanation || '',
    image_name: q.imageName || null,
    score_value: q.scoreValue || 1,
    category: category,
    question_number: q.id || index + 1
  }));

  // Ulož do cache
  questionsCache[category] = formattedQuestions;
  lastFetchTime = Date.now();

  console.log(`questionsApi: Načteno ${formattedQuestions.length} otázek pro ${category}`);
  return formattedQuestions;
}

export const questionsApi = {
  // Načíst všechny kategorie s počtem otázek
  async getCategories() {
    const categories = ['Biologie', 'Chemie', 'Fyzika', 'Somatologie'];
    const result = [];

    for (const category of categories) {
      const questions = await fetchFromFirebase(category);
      result.push({
        name: category,
        count: questions.length
      });
    }

    return result;
  },

  // Načíst otázky podle kategorie
  async getQuestionsByCategory(category, limit = null) {
    const questions = await fetchFromFirebase(category);

    if (limit) {
      return questions.slice(0, limit);
    }

    return questions;
  },

  // Načíst otázky podle kategorie seřazené podle question_number
  async getQuestionsSorted(category, count = null) {
    const questions = await fetchFromFirebase(category);

    // Seřadit podle question_number
    const sorted = [...questions].sort((a, b) => a.question_number - b.question_number);

    if (count) {
      return sorted.slice(0, count);
    }

    return sorted;
  },

  // Načíst náhodné otázky podle kategorie
  async getRandomQuestions(category, count = 10) {
    const questions = await fetchFromFirebase(category);

    // Náhodné zamíchání a výběr
    const shuffled = [...questions].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, count);
  },

  // Načíst náhodné otázky ze všech kategorií (pro simulaci)
  async getSimulationQuestions(questionsPerCategory = { Biologie: 15, Chemie: 15, Fyzika: 15, Somatologie: 5 }) {
    const allQuestions = [];

    for (const [category, count] of Object.entries(questionsPerCategory)) {
      const questions = await this.getRandomQuestions(category, count);
      allQuestions.push(...questions);
    }

    // Zamíchat všechny otázky
    return allQuestions.sort(() => Math.random() - 0.5);
  },

  // Načíst jednu otázku podle ID
  async getQuestionById(id) {
    // Prohledat všechny kategorie
    const categories = ['Biologie', 'Chemie', 'Fyzika', 'Somatologie'];

    for (const category of categories) {
      const questions = await fetchFromFirebase(category);
      const found = questions.find(q => q.id === id);
      if (found) return found;
    }

    return null;
  },

  // Invalidovat cache (pro ruční refresh)
  invalidateCache() {
    questionsCache = {};
    lastFetchTime = null;
    console.log('questionsApi: Cache invalidována');
  }
};
